import registerModules from "seneca-common/features/module/module-types/registerModules";
import { ModuleRegistry } from "seneca-common/features/module/registry/index";

import registerComponentStaticInformation from "features/module/module-types/registerComponentStaticInformation";

export default function registerModuleStaticInformationForClassroom(
  moduleRegistry: ModuleRegistry = ModuleRegistry.getInstance()
) {
  registerModules(moduleRegistry);
  registerComponentStaticInformation(moduleRegistry);
}
